// pages/treach/sectionpages/CampaignsSection.jsx
import React from "react";

const CampaignsSection = ({ usecase }) => {
  return (
    <div className="text-gray-200 text-sm">
      <p>
        📂 <strong>Dummy Campaign Overview</strong> for {usecase}
      </p>
      <ul className="list-disc list-inside mt-3 text-gray-400">
        <li>Objective: Brand awareness in Tier-1 cities</li>
        <li>Duration: 4 weeks</li>
        <li>Budget: ₹2,50,000</li>
        <li>Status: 🟢 Active</li>
      </ul>
    </div>
  );
};

export default CampaignsSection;
